import { FaPhoneAlt, FaShip } from 'react-icons/fa';
import { CRUISE_PHONE_TEL } from '../../constants/contact';
import { getCruiseCityMeta, getRegionImage } from '../../constants/cruiseImages';

function formatDate(value) {
  if (!value) return 'Flexible dates';
  const d = new Date(`${value}T12:00:00`);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export default function CruiseResultCard({ item, searchParams }) {
  const depart = formatDate(item.departDate || searchParams?.get('depart'));
  const guests = searchParams?.get('guests') || '2';
  const cityMeta = getCruiseCityMeta(item.port);
  const regionImage = getRegionImage(item.destination);

  return (
    <article className="cruise-result-card">
      <div className="cruise-result-card__thumb">
        <img src={regionImage} alt={`${item.destination} cruise sailing`} loading="lazy" />
        <span className="cruise-city-badge">{item.destination}</span>
      </div>
      <div className="cruise-result-card__main">
        <div className="cruise-result-card__line">
          <FaShip aria-hidden />
          <div>
            <h3>{item.line}</h3>
            <p>
              {cityMeta.city} → {item.destination} · {item.nights} nights
            </p>
          </div>
        </div>
        <div className="cruise-result-card__meta">
          <span>
            <strong>Depart</strong> {depart}
          </span>
          <span>
            <strong>Port</strong> {cityMeta.city}
          </span>
          <span>
            <strong>Cabin</strong> {item.cabin}
          </span>
          <span>
            <strong>Guests</strong> {guests}
          </span>
        </div>
      </div>
      <div className="cruise-result-card__book">
        <div className="cruise-result-card__price">
          <span className="cruise-result-card__amount">${item.price.toFixed(0)}</span>
          <span className="cruise-result-card__per">per guest</span>
          <span className="cruise-result-card__fine">incl. taxes & fees</span>
        </div>
        <a href={`tel:${CRUISE_PHONE_TEL}`} className="cruise-result-card__cta">
          <FaPhoneAlt aria-hidden />
          Call to book
        </a>
      </div>
    </article>
  );
}
